/**
 * Formats a customer rating into a string with a specific number of decimal places.
 *
 * - If the rating is exactly 10, the function returns the rating as a whole number string.
 * - For any other rating value, the function returns the rating as a string with one decimal place.
 *
 * @param {number} rating - The customer rating to be formatted.
 * @param {number} scaleDivider - The customer rating divider, defaults to 1.
 * @returns {string} - The formatted rating as a string.
 */
export function formatCustomerRating(rating, scaleDivider = 2) {
    const scaled = scaleDivider === 1 ? rating : rating / scaleDivider;
    return Number.isInteger(scaled) ? scaled.toString() : scaled.toFixed(1);
}
